import { IInitialState } from "./types";

export const initialState: IInitialState = {
  getCloudStorage: {
    params: {
      page: 1,
      applicationId: null,
      pageSize: 10,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  getCloudStorageById: {
    params: {
      fileId: null,
      page: 1,
      pageSize: 10,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
}